(function () {
  'use strict';

  const mobileBreakpoint = window.matchMedia('(max-width: 1024px)');
  const swipeThreshold = 40;

  function isMobileViewport() {
    return mobileBreakpoint.matches;
  }

  function shouldHideArrowsOnMobile(carousel) {
    return carousel.dataset.hideArrowsMobile === 'true';
  }

  function shouldEnableSwipeOnMobile(carousel) {
    return carousel.dataset.enableSwipeMobile === 'true';
  }

  function updateMobileControls(carousel) {
    const navButtons = carousel.querySelector('.znt-flex-carousel_nav-buttons');

    if (!navButtons) {
      return;
    }

    if (isMobileViewport() && shouldHideArrowsOnMobile(carousel)) {
      navButtons.hidden = true;
      navButtons.setAttribute('aria-hidden', 'true');
      navButtons.style.display = 'none';
      carousel.setAttribute('data-mobile-controls', 'swipe-dots');
      return;
    }

    navButtons.hidden = false;
    navButtons.removeAttribute('aria-hidden');
    navButtons.style.display = '';
    carousel.removeAttribute('data-mobile-controls');
  }

  function bindSwipe(carousel) {
    const wrapper = carousel.querySelector('.znt-flex-carousel_wrapper');

    if (!wrapper || wrapper.dataset.swipeBound === 'true') {
      return;
    }

    let startX = 0;
    let startY = 0;
    let tracking = false;
    let suppressClick = false;

    function onTouchStart(event) {
      if (
        !isMobileViewport() ||
        !shouldEnableSwipeOnMobile(carousel) ||
        !event.touches ||
        event.touches.length !== 1
      ) {
        tracking = false;
        return;
      }

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
      suppressClick = false;
    }

    function onTouchEnd(event) {
      const instance = carousel.zenythCarouselInstance;

      if (
        !tracking ||
        !isMobileViewport() ||
        !shouldEnableSwipeOnMobile(carousel) ||
        !event.changedTouches ||
        event.changedTouches.length !== 1 ||
        !instance
      ) {
        tracking = false;
        return;
      }

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      tracking = false;

      if (absDeltaX < swipeThreshold || absDeltaX <= absDeltaY) {
        return;
      }

      suppressClick = true;

      if (deltaX < 0) {
        instance.nextSlide();
      } else {
        instance.previousSlide();
      }

      window.setTimeout(function () {
        suppressClick = false;
      }, 250);
    }

    function onClickCapture(event) {
      if (!suppressClick) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }

    wrapper.addEventListener('touchstart', onTouchStart, { passive: true });
    wrapper.addEventListener('touchend', onTouchEnd, { passive: true });
    wrapper.addEventListener('click', onClickCapture, true);
    wrapper.dataset.swipeBound = 'true';
  }

  function initializeAutoplay(carousel) {
    if (carousel.dataset.autoplay !== 'true' || carousel.dataset.autoplayBound === 'true') {
      return;
    }

    // Delay autoplay until the first user interaction. This is also the moment
    // Google finalizes the LCP score, so by definition this can't regress LCP.
    function startAutoplay() {
      const autoplayButton = carousel.querySelector('[data-autoplay-button]');

      if (!autoplayButton || carousel.dataset.autoplayBound === 'true') {
        return;
      }

      autoplayButton.click();
      carousel.dataset.autoplayBound = 'true';
    }

    const interactionEvents = ['pointerdown', 'scroll', 'wheel', 'touchstart', 'keydown'];

    function onFirstInteraction() {
      interactionEvents.forEach(function (eventName) {
        window.removeEventListener(eventName, onFirstInteraction);
      });
      startAutoplay();
    }

    interactionEvents.forEach(function (eventName) {
      window.addEventListener(eventName, onFirstInteraction, { once: true, passive: true });
    });
  }

  function initializeHeroCarouselCustom() {
    const carousels = document.querySelectorAll(
      '.znt-flex-carousel[aria-roledescription="carousel"]'
    );

    carousels.forEach(function (carousel) {
      updateMobileControls(carousel);
      bindSwipe(carousel);
      initializeAutoplay(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHeroCarouselCustom);
  } else {
    initializeHeroCarouselCustom();
  }

  if (typeof mobileBreakpoint.addEventListener === 'function') {
    mobileBreakpoint.addEventListener('change', initializeHeroCarouselCustom);
  } else if (typeof mobileBreakpoint.addListener === 'function') {
    mobileBreakpoint.addListener(initializeHeroCarouselCustom);
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeHeroCarouselCustom);
    document.addEventListener('shopify:section:reorder', initializeHeroCarouselCustom);
    document.addEventListener('shopify:section:select', initializeHeroCarouselCustom);
    document.addEventListener('shopify:section:deselect', initializeHeroCarouselCustom);
    document.addEventListener('shopify:block:select', initializeHeroCarouselCustom);
    document.addEventListener('shopify:block:deselect', initializeHeroCarouselCustom);
  }
})();
